module.exports = "## Tab\n\n> Tab导航\n\n### 使用说明\n\n* `items`\n    * Array<name: 'tabShowName', tab: 'tabName', children: []>\n\n\n* 事件名称\n    * `tab-change`\n\n\n```html\n<tab :params=\"params\"\n    @tab-change=\"changeValue\"></tab>\n```\n\n```js\nimport Tab from 'smui/Tab'\n\nconst params = [\n    {name: '表格', tab: 'table'},\n    {name: '表单', tab: 'form'},\n    {\n        name: '消息',\n        tab: 'dialog',\n        subTab: 'message',\n        children: [\n            {name: '消息', tab: 'message'},\n            {name: '弹窗', tab: 'dialog'}\n        ]\n    }\n]\n```"


//////////////////
// WEBPACK FOOTER
// ../~/.0.5.1@raw-loader!./docs/components/Tab.md
// module id = 407
// module chunks = 1 4